
<header id="header" class="header fixed-top d-flex align-items-center">

  <div class="d-flex align-items-center justify-content-between">
    <a routerLink="/dashboardmkt"  class="logo d-flex align-items-center">
      <img src="assets/img/logo.png" alt="">
      <span class="d-none d-lg-block">AdminMkt</span>
    </a>
    <i class="bi bi-list toggle-sidebar-btn"></i>
  </div>






  <nav class="header-nav ms-auto">
    <div class="dropdown text-end">
      {{user.username}}
      <a href="#" class="d-block link-body-emphasis text-decoration-none dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
        <img src="{{ user.avatar }}" alt="{{user.username}}" width="32" height="32" class="rounded-circle"> {{user.username}}
      </a>
      <ul class="dropdown-menu text-small">
        <li><button class="dropdown-item"  data-bs-toggle="modal" data-bs-target="#exampleModal">Cambiar Contraseña</button></li>

        <li><hr class="dropdown-divider"></li>
        <li><button class="dropdown-item" (click)="logout()">Salir </button></li>
      </ul>
    </div>
  </nav>

</header><!-- End Header -->

<!-- ======= Sidebar ======= -->
<aside #sidebar id="sidebar" class="sidebar">

  <ul class="sidebar-nav" id="sidebar-nav">

    <li class="nav-item">
      <a class="nav-link " routerLink="/dashboardmkt" routerLinkActive="active">
        <i class="bi bi-grid"></i>
        <span>Dashboard</span>
      </a>
    </li><!-- End Dashboard Nav -->
    <li class="nav-item"  (click)="showHidden()">
      <a class="nav-link collapsed" routerLink="/dashboardmkt/herosHome">
        <i class="bi bi-house-add"></i>
        <span>Hero's Home</span>
      </a>
    </li>

    <li class="nav-item">
      <a class="nav-link collapsed" data-bs-target="#components-nav" data-bs-toggle="collapse" href="#">
        <i class="bi bi-menu-button-wide"></i><span>Promociones</span><i class="bi bi-chevron-down ms-auto"></i>
      </a>
      <ul id="components-nav" class="nav-content collapse " data-bs-parent="#sidebar-nav">
        <li  (click)="showHidden()">
          <a routerLink="/dashboardmkt/promocionesSam" routerLinkActive="active">
            <i class="bi bi-circle"></i><span>Promociones Sam</span>
          </a>
        </li>
        <li  (click)="showHidden()">
          <a routerLink="/dashboardmkt/promocionesWeb" routerLinkActive="active">
            <i class="bi bi-circle"></i><span>Promociones Web</span>
          </a>
        </li>

      </ul>
    </li>
    <li class="nav-item"  (click)="showHidden()">
    <a class="nav-link collapsed" routerLink="/dashboardmkt/especialidadesWeb">
      <i class="bi bi-capsule"></i>
      <span>Especialidades</span>
    </a>
  </li>
    <li class="nav-item"  (click)="showHidden()">
    <a class="nav-link collapsed" routerLink="/dashboardmkt/sucursalesHorarios">
      <i class="bi bi-calendar-date"></i>
      <span>Sucursales - Horarios</span>
    </a>
  </li>
    <li class="nav-item"  (click)="showHidden()">
    <a class="nav-link collapsed" routerLink="/dashboardmkt/usuariosmkt">
      <i class="bi bi-people"></i>
      <span>Usuarios</span>
    </a>
  </li>

<!--    <li class="nav-heading">Pages</li>-->






  </ul>

</aside><!-- End Sidebar-->



<div #editPassword class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel">Cambiar contraseña</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form action="" [formGroup]="formUpdatePassword">
          <div class="mb-3">
            <label for="passwordActual" class="form-label fs-6">Contraseña Actual</label>
            <input formControlName="passOld" type="password" class="form-control" id="passwordActual" aria-describedby="password">
          </div>

          <div class="mb-3">
            <label for="passwordNew" class="form-label fs-6">Nueva Contraseña</label>
            <input formControlName="passNew" type="password" class="form-control" id="passwordNew" aria-describedby="password">
          </div>
          <div class="mb-3">
            <label for="passwordNewRepeat" class="form-label fs-6">Repetir Nueva Contraseña</label>
            <input formControlName="passNewRepeat" type="password" class="form-control" id="passwordNewRepeat" aria-describedby="password">
          </div>
        </form>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" (click)="updatePassword()">Guardar</button>
      </div>
    </div>
  </div>
</div>
